import { api } from "./api";

export const getSubscription = () => api.get("/subscription").then((r) => r.data);
export const listPlans = () => api.get("/subscription/plans").then((r) => r.data);
export const selectPlan = (plan) => api.post("/subscription/select-plan", { plan }).then((r) => r.data);
export const logReportDownload = (reportId) =>
  api.post(`/reports/${reportId}/log-download`).then((r) => r.data);

// Helper: detect HTTP 402 quota-exceeded responses (server returns
// { detail: {error:'quota_exceeded', resource, used, limit, plan, message} })
export const isQuotaError = (err) => {
  const s = err?.response?.status;
  const d = err?.response?.data?.detail;
  return s === 402 && d && d.error === "quota_exceeded";
};
export const quotaErrorPayload = (err) => err?.response?.data?.detail || null;
